import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { post } from '@rails/request.js'

export default class extends Controller {
  static values = {
    hideUrl: String
  }

  static classes = ['shown', 'hidden']

  connect() {
    this.show()
  }

  // ! If this function is renamed, remember that it is used in pop-up content by marketing team
  async postHide(event) {
    event.preventDefault()
    // This is needed because the marketing team is attaching a data-action listener to anchor tags in the pop-up content
    const redirectionUrl = event.currentTarget.href
    try {
      await post(this.hideUrlValue)
    } finally {
      this.hide()
      if (redirectionUrl) {
        Turbo.visit(redirectionUrl)
      }
    }
  }

  show() {
    this.element.classList.add(...this.shownClasses)
  }

  hide() {
    this.element.classList.add(...this.hiddenClasses)
    setTimeout(() => this.element.remove(), 1000)
  }
}
